import firstImage from 'src/medias/images/Sliders/slider-1.png';
import tenthImage from 'src/medias/images/Sliders/slider-10.png';
import eleventhImage from 'src/medias/images/Sliders/slider-11.png';
import secondImage from 'src/medias/images/Sliders/slider-2.png';
import thirdImage from 'src/medias/images/Sliders/slider-3.png';
import fourthImage from 'src/medias/images/Sliders/slider-4.png';
import fifthImage from 'src/medias/images/Sliders/slider-5.png';
import sixthImage from 'src/medias/images/Sliders/slider-6.png';
import seventhImage from 'src/medias/images/Sliders/slider-7.png';
import eightthImage from 'src/medias/images/Sliders/slider-8.png';
import ninethImage from 'src/medias/images/Sliders/slider-9.png';

export const sliderData = [
  {
    url: firstImage,
    dialogTitle: `NANYANG 102ND FOUNDER'S DAY`,
    dialogContent:
      '今年母校将庆祝成立102周年，与此同时也欢庆30及50年南洋毕业生的团聚。今年校庆的主题是“回忆”。我们诚挚的邀请南洋的学子们与1989年及1969年的毕业生参',
  },
  {
    url: secondImage,
    dialogTitle: '2018年上半年活动项目',
    dialogContent: '校友会为大家准备的2018年上半年活动项目,希望大家踊跃出席。',
  },
  {
    url: thirdImage,
    dialogTitle: '99TH FOUNDER’S DAY',
    dialogContent: '餐费每位50元/特价每位40元*',
  },
  {
    url: fourthImage,
    dialogTitle: '南洋新春团拜2016',
    dialogContent: '南洋新春团拜2016',
  },
  {
    url: fifthImage,
    dialogTitle: '1965 毕业班同学在母校98校庆对母校的感恩',
    dialogContent: '1965 毕业班同学在母校98校庆对母校的感恩',
  },
  {
    url: sixthImage,
    dialogTitle: "98TH FOUNDER'S DAY",
    dialogContent: `98校庆的主题是‘叙’，母校校庆之际，她像慈母般热情的期待我们的归来共叙旧谊
      `,
  },
  {
    url: seventhImage,
    dialogTitle: '南洋校友会柬埔寨爱心之旅 (一) 和 (二)',
    dialogContent: '南洋校友会柬埔寨爱心之旅 (一) 和 (二)',
  },
  {
    url: eightthImage,
    dialogTitle: '悼念敬爱的建国总理李光耀国父',
    dialogContent: '南洋中小幼校友会谨此以万二分悲痛的心情向您致以最崇高的敬意。',
  },
  {
    url: ninethImage,
    dialogTitle: '团拜 2015',
    dialogContent:
      '在新春伊始与 南洋大家庭同欢共庆，保持团拜传统，与退休校长及老师，校友，三校师生及家长，为新的一年献上彼此的祝福。 节目包括舞狮，团体书法，歌舞表',
  },
  {
    url: tenthImage,
    dialogTitle: '探访陈金浪老师',
    dialogContent:
      '像往年一样，中秋佳节是南洋中小幼校友会去探访退休老师的日子。2014年8月30日是许多校友会成员，校友们和南洋中小幼校友合唱团团员与陈金浪老师和家人的中',
  },
  {
    url: eleventhImage,
    dialogTitle: '校友回校日嘉年华会',
    dialogContent:
      '南洋女中在8月16日早上9点到傍晚6点举办了校友回校日嘉年华会。嘉年华会所筹得的款项将用于学校的各项发展计划与添置配备，并将部分的款项捐给弱势人士',
  },
];
